// extracted by mini-css-extract-plugin
export default {"quickAction":"QuickAction_quickAction__tDFiM"};